<template>
    <div>
        <el-form ref="form" :rules="rules" :model="form" label-width="100px">
            <el-form-item label="项目封面:" prop="photo">
                <el-upload class="avatar-uploader" action="api/myproject/upphoto" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="form.photo" :src="form.photo" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="项目名称:" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="项目描述:" prop="description">
                <quill-editor v-model="form.description"  />
            </el-form-item>
            <el-form-item label="项目时间:" prop="time">
                <el-date-picker v-model="form.time" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="项目开关:">
                <el-switch v-model="form.switch" active-color="#13ce66" inactive-color="#ff4949" inactive-value=0
                    active-value=1>
                </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="onSubmit('form')">{{
                    editID == 0 ? "添加" : "修改"
                }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        editID: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            imageUrl: "",
            form: {
                photo: '',
                name: '',
                description: '',
                time: '',
                switch: 0
            },
            rules: {
                photo: [{ required: true, message: "请上传项目封面", trigger: "blur" }],
                name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
                time: [{ required: true, message: "请选择项目时间", trigger: "blur" }],
                description: [{ required: true, message: "请输入项目描述", trigger: "blur" }],
            },
        };
    },
    methods: {
        handleAvatarSuccess(res, file) {
            console.log(res);
            if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
          // this.form.photo = URL.createObjectURL(file.raw);
            this.form.photo = res.data;
            this.$message.success(res.meta.msg);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error("上传封面图片只能是 JPG或者PNG 格式!");
            }
            if (!isLt5M) {
                this.$message.error("上传封面图片大小不能超过 5MB!");
            }
            return isJPG && isLt5M;
        },
        onSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (!valid) {
                    this.$message.error("添加失败");
                    return false;
                }
                if (this.editID > 0) {
                    const { data: res } = await this.$axios.post(
                        "/myproject/editProject",
                        this.form
                    );
                    console.log(res);
                    if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
                    this.$emit("onDialog", false);
                    return this.$message.success(res.meta.msg);
                } else {
                    const { data: res } = await this.$axios.post(
                        "myproject/addProject",
                        this.form
                    );
                    console.log(res);
                    if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
                    this.$emit("onDialog", false);
                    return this.$message.success(res.meta.msg);
                }
            });
        },
        async getProject(id) {
            const { data: res } = await this.$axios.post("/myproject/getProjectId", {
                id: id,
            });
            console.log(res);
            this.form = res.data;
        },
    },
    created() {
        if (this.editID > 0) {
            console.log(this.editID);
            this.getProject(this.editID);
        }
    },
}
</script>

<style lang="less">
.avatar-uploader .el-upload {
    border: 1px dashed #666;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff !important;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-input,
.el-textarea {
    max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/myproject/addProject.vue